import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "@bt/core/base";
import { LegalDomainModel, LegalDomainService, UserService} from "@bt/core";
import { faPlus, faTrashAlt, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { NotifierService } from "angular-notifier";
import { NgbModal,NgbActiveModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { DeleteUserModalContent } from '@bt/admin/all-users/delete-users-modal';
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup, FormBuilder, Validators, FormsModule,FormArray,AbstractControl, FormControl } from "@angular/forms";


@Component({
  selector: 'app-legal-domain',
  templateUrl: './legal-domain.component.html',
  styleUrls: ['./legal-domain.component.scss']
})
export class LegalDomainComponent extends BaseComponent implements OnInit {

  faPlus = faPlus;
  faTrashAlt = faTrashAlt;
  faPencilAlt = faPencilAlt;

  public isResponsed: boolean = false;
  public hasInfo:boolean = false;

  public isSmthChecked: boolean;
  public modalRef: NgbModalRef;
  public validForm: FormGroup;
  newOrEditLegalDomain: LegalDomainModel;

  legalDoamins = new Array<LegalDomainModel>();

  notifier: any;

  constructor(
    private router: Router,
    private legalDomainService: LegalDomainService,
    notifierService: NotifierService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private userService: UserService,
    private fb: FormBuilder,
  ) {
    super();
    this.notifier = notifierService;
   }

  ngOnInit() {
    this.validForm = this.fb.group({
      textLegalDomain:     ["", [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.pattern(this.linkPattern)]],
    });
    this.newOrEditLegalDomain = new LegalDomainModel();
    this.GetLegalDomain();
  }

  get textLegalDomain()     { return this.validForm.get('textLegalDomain'); }

  GetLegalDomain(){
    this.setLoading(true);
    this.legalDomainService.GetLegalDomain()
    .then((resp) => {
      this.legalDoamins = resp.data;
      this.hasInfo = resp.data.length != 0;
      this.isResponsed = true;
      this.setLoading(false);
    })
    .catch((error)=>{
      this.notifier.notify('error', "Ошибка при получении списка доменов");
      this.hasInfo = false;
      this.isResponsed = true;
      this.setLoading(false);
    });
  }

  AddNewLegalDomain(){
    this.newOrEditLegalDomain = new LegalDomainModel();
  }

  EditLegalDomain(legalDomainToEdit: LegalDomainModel){
    this.newOrEditLegalDomain = this.copyObject(legalDomainToEdit);
  }

  CreateOrEditLegalDomain(domainModel: LegalDomainModel){
    this.setLoading(true);
    if (!this.validForm.valid) {
      this.setLoading(false);
      this.notifier.notify('error', "Проверьте корректность данных");
      this.markFormGroupTouchedAndDirty(this.validForm);
      return;
    }
    this.legalDomainService.CreateOrEditLegalDomain(domainModel)
    .then((resp) => {
      this.notifier.notify('success', "Сохранено");
      this.setLoading(false);
      this.GetLegalDomain();
    })
    .catch((error)=>{
      var text = this.GetErrorMessageText("Не удалось сохранить данные домена", error);
      this.notifier.notify('error', text);

      this.setLoading(false);
    });

  }

  public isChecked()
  {
    this.isSmthChecked = false;
    this.legalDoamins.forEach(temp => {
      if (temp.isDeleted == true)
      {
        this.isSmthChecked = true;
      }
    });
    return this.isSmthChecked;
  }

  public openDeleteLegalDomains(){
    let t=this;
    t.modalRef = t.modalService.open(DeleteUserModalContent,
      {
        backdropClass: 'light-white-backdrop',
        centered: true ,
        size: 'sm',
        windowClass:'super-modal-delete-users very-nice-shadow',

      });
      t.modalRef.componentInstance.isNeedDelete=false;
      t.modalRef.componentInstance.title = "Удаление";
      t.modalRef.componentInstance.description="Вы действительно хотите удалить отмеченное?";
      t.modalRef.componentInstance.button = "Удалить";
      t.modalRef
      .result.then((result)=>{
        if(result){
          t.setLoading(true);
          var legalDomainTodelete = [];
          t.legalDoamins.forEach(oneLegDom => {
            if(oneLegDom.isDeleted){
              legalDomainTodelete.push(oneLegDom);
            }
          });

          t.legalDomainService.DeleteLegalDomain(legalDomainTodelete)
          .then((resp) => {
            if (resp.data == true) {
              t.notifier.notify('success', "Успешно удалено");
              t.setLoading(false);
              t.GetLegalDomain();
            }
          })
          .catch((error) => {
            t.setLoading(false);
        //console.error(error.error);
          });
        }
      },
      (reason) => {
        //если отменили нажали на крестик или мимо окна
      })
  }

  public getRole():number {
		return this.userService.getRole();
  }

}



// WEBPACK FOOTER //
// ./src/app/legal-domain/legal-domain.component.ts